import { p as post, f as formDataPost } from "./api.js";
import { c as currentProject } from "./projectWizard.js";
import { c as currentCustomer } from "./customer.js";
const timelineItemForFileUpload = async (project2, fileName) => {
  return await post("/timeline/" + project2.uuid, {
    title: "Neue Datei hochgeladen",
    description: `Die Datei ${fileName} wurde hochgeladen.`,
    type: "important"
  });
};
let customerUUID;
currentCustomer.subscribe((val) => {
  if (val && typeof val.uuid !== "undefined") {
    customerUUID = val.uuid;
  }
});
let project;
currentProject.subscribe((val) => {
  if (val) {
    project = val;
  }
});
const storeFiles = async (newFiles) => {
  const results = [];
  if (typeof project.uuid !== "undefined") {
    for (let i = 0; i < newFiles.length; i++) {
      try {
        const res = await formDataPost("/document/" + customerUUID, {
          file: newFiles[i],
          name: newFiles[i].name,
          projectUuid: project.uuid
        });
        results.push(res);
        await timelineItemForFileUpload(project, newFiles[i].name);
      } catch (e) {
        console.error(e);
      }
    }
  }
  console.log(results);
  return results;
};
export {
  storeFiles as s
};
//# sourceMappingURL=files.js.map
